import "./orderList.css";
import Table from "../../components/advancedTable";
import {
    Close,
    LocalGroceryStore,
    CloudDownload,
    VerifiedUser,
    Edit,
    AttachFile,
    Comment,
    Description,
    Assignment,
    Delete,
    Event,
    Receipt,
    Payment,
} from "@material-ui/icons";
import { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
    getOrders,
    voidOrder,
    acceptOrder,
    generateSignature,
} from "../../redux/apiCalls";
import moment from "moment";
import { orderTotalDue, orderBalanceDue, sstAmount } from "../../helpers/sst";
import { FiFile, FiPlus } from "react-icons/fi";
import { publicRequest } from "../../requestMethods";
import createCustomerInvoice from "../../components/pdf/createCustomerInvoice";
import createQuotation from "../../components/pdf/createQuotation";
import createOfficialReceipt from "../../components/pdf/createOfficialReceipt";
import createProposal from "../../components/pdf/createProposal";
import excel from "../../components/excel/excel";
import { useLocation } from "react-router";
import { useHistory } from "react-router";
import createBulk from "../../components/pdf/createBulk";
import { userRequest } from "../../requestMethods";
import { useForm } from "react-hook-form";
import axios from "axios";
import { clearCart, editOrderSeedData } from "../../redux/cartRedux";

const statusOptions = [
    {
        label: "Pending",
        value: "pending",
    },
    {
        label: "Completed",
        value: "completed",
    },
    {
        label: "Void",
        value: "void",
    },
    {
        label: "Installment",
        value: "installment",
    },
    {
        label: "All",
        value: "",
    },
];

const limitOptions = [
    {
        label: "Standard (20 items)",
        value: 20,
    },
    {
        label: "Export All",
        value: 9999,
    },
];

export default function WarrantyList() {
    const formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const superadmin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isSuperAdmin : null
    );
    const [isLoaded, setIsLoaded] = useState(false);
    const currentUser = useSelector((state) => state.user.currentUser);

    const staff = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.type === "staff" : null
    );

    const admin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isAdmin : null
    );

    const accountant = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "accountant"
            : null
    );

    const outright = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "outright"
            : null
    );

    const salesperson = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "salesperson"
            : null
    );

    const principle = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.principle : null
    );

    const buildDefaultInputs = useCallback(
        () => ({
            cashier:
                superadmin || salesperson
                    ? undefined
                    : outright
                      ? undefined
                      : currentUser?._id,
            status: undefined,
            limit: 20,
            page: 1,
            dateFrom: moment("2026-01-01").format("YYYY-MM-DD"),
            dateTo: moment().add(2, "days").format("YYYY-MM-DD"),
            salesperson: salesperson ? currentUser?._id : undefined,
            createdBy: salesperson
                ? undefined
                : location
                  ? location.state
                      ? location.state.outlet
                      : superadmin
                        ? undefined
                        : principle?._id || currentUser?._id
                  : superadmin
                    ? undefined
                    : principle?._id || currentUser?._id,
        }),
        [currentUser?._id, location, outright, principle, salesperson, superadmin]
    );

    const [inputs, setInputs] = useState(buildDefaultInputs);

    const [statusMenu, setStatusMenu] = useState(false);
    const [ordersData, setOrdersData] = useState(false);
    const [voidMenu, setVoidMenu] = useState(false);
    const [acceptMenu, setAcceptMenu] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [usersData, setUsersData] = useState([]);
    const [customersData, setCustomersData] = useState([]);
    const [suppliersData, setSuppliersData] = useState([]);
    const [serialNumber, setSerialNumber] = useState(undefined);
    const [payloadpaymentType, setPayloadPaymentType] = useState("cash");
    const [installmentMenu, setInstallmentMenu] = useState(false);
    const [manualInstallmentMenu, setManualInstallmentMenu] = useState(false);
    const [warrantyMenu, setWarrantyMenu] = useState(false);
    const [invoice, setInvoice] = useState(undefined);
    const [coNumber, setCoNumber] = useState(undefined);
    const [galleryModalState, setGalleryModalState] = useState(false);
    const [photoGalleryModalState, setPhotoGalleryModalState] = useState(false);
    const [galleryViewModalState, setGalleryViewModalState] = useState(false);
    const [selectedOrderGallery, setSelectedOrderGallery] = useState(null);
    const [isUploadingGallery, setIsUploadingGallery] = useState(false);
    const [uploadProgress, setUploadProgress] = useState({ current: 0, total: 0 });
    const [commenceDate, setCommenceDate] = useState(undefined);
    const [amount, setAmount] = useState(undefined);
    const [installmentDiscount, setInstallmentDiscount] = useState(0);
    const [cardInterest, setCardInterest] = useState(0);
    const [installmentRemarks, setInstallmentRemarks] = useState("");
    const [remarksMenu, setRemarksMenu] = useState(false);
    const [selectedRemarks, setSelectedRemarks] = useState("");
    const [objectivesMenu, setObjectivesMenu] = useState(false);
    const [milestonesMenu, setMilestonesMenu] = useState(false);
    const [monthlyFeeMenu, setMonthlyFeeMenu] = useState(false);
    const [filterResetKey, setFilterResetKey] = useState(0);
    const findOption = useCallback(
        (options, value) => options.find((opt) => opt.value === value) || null,
        []
    );
    // eslint-disable-next-line
    const [paymentType, setPaymentType] = useState([
        { value: "cash", label: "Cash" },
        { value: "card", label: "Card" },
        { value: "cheque", label: "Cheque" },
        { value: "onlineTransfer", label: "Online Transfer" },
    ]);

    const {
        register: galleryRegister,
        handleSubmit: handleGallerySubmit,
        getValues: getGalleryValues,
        reset: resetGallery,
    } = useForm({
        defaultValues: {
            image: "",
        },
    });

    const {
        register: photoGalleryRegister,
        handleSubmit: handlePhotoGallerySubmit,
        getValues: getPhotoGalleryValues,
        reset: resetPhotoGallery,
    } = useForm({
        defaultValues: {
            image: "",
        },
    });

    const {
        register: warrantyRegister,
        handleSubmit: handleWarrantySubmit,
        getValues: getWarrantyValues,
        reset: resetWarranty,
    } = useForm({
        defaultValues: {
            message: "",
            image: "",
        },
    });

    const {
        register: objectivesRegister,
        handleSubmit: handleObjectivesSubmit,
        getValues: getObjectivesValues,
        reset: resetObjectives,
    } = useForm({
        defaultValues: {
            objective: "",
        },
    });

    const {
        register: milestonesRegister,
        handleSubmit: handleMilestonesSubmit,
        getValues: getMilestonesValues,
        reset: resetMilestones,
    } = useForm({
        defaultValues: {
            modules: "",
            dueDate: "",
        },
    });

    const {
        register: monthlyFeeRegister,
        handleSubmit: handleMonthlyFeeSubmit,
        getValues: getMonthlyFeeValues,
        reset: resetMonthlyFee,
    } = useForm({
        defaultValues: {
            monthlyFees: "",
        },
    });

    const handleAddGallery = async () => {
        try {
            const formValues = getGalleryValues();

            let newImage = undefined;

            if (formValues.image.length !== 0) {
                const imageresult = await generateSignature();
                const imageFormData = new FormData();

                imageFormData.append("file", formValues.image[0]);
                imageFormData.append(
                    "publicKey",
                    "public_0THMWX6MF/cuVk9EPEFy+e0R0Qk="
                );
                imageFormData.append("signature", imageresult.data.signature);
                imageFormData.append("expire", imageresult.data.expire);
                imageFormData.append("token", imageresult.data.token);
                imageFormData.append(
                    "fileName",
                    `${formValues.image[0].name} - ${imageresult.data.expire}`
                );
                imageFormData.append("folder", "banners");

                const imageUploadResult = await axios.post(
                    "https://upload.imagekit.io/api/v1/files/upload",
                    imageFormData
                );

                newImage = imageUploadResult.data.url;
            }

            const result = await userRequest.post("/orders/addpaymentproof", {
                img: newImage,
                order: modalData._id,
            });

            if (result.error) {
                alert("Failed");
            }

            if (result.data) {
                // do success stuff
                resetGalleryModal();
                alert("Success");
                window.location.reload();
            }
        } catch (err) {
            //do err stuff
            alert("Failed");
            console.log(err);
        }
    };

    const handleAddPhotoGallery = async () => {
        try {
            const formValues = getPhotoGalleryValues();

            if (formValues.image.length === 0) {
                alert("Please select at least one image");
                return;
            }

            const uploadedImages = [];
            const totalImages = formValues.image.length;

            // Start loading
            setIsUploadingGallery(true);
            setUploadProgress({ current: 0, total: totalImages });

            // Upload each image
            for (let i = 0; i < formValues.image.length; i++) {
                try {
                    setUploadProgress({ current: i + 1, total: totalImages });

                    const imageresult = await generateSignature();
                    const imageFormData = new FormData();

                    imageFormData.append("file", formValues.image[i]);
                    imageFormData.append(
                        "publicKey",
                        "public_0THMWX6MF/cuVk9EPEFy+e0R0Qk="
                    );
                    imageFormData.append("signature", imageresult.data.signature);
                    imageFormData.append("expire", imageresult.data.expire);
                    imageFormData.append("token", imageresult.data.token);
                    imageFormData.append(
                        "fileName",
                        `${formValues.image[i].name} - ${imageresult.data.expire}`
                    );
                    imageFormData.append("folder", "gallery");

                    const imageUploadResult = await axios.post(
                        "https://upload.imagekit.io/api/v1/files/upload",
                        imageFormData
                    );

                    uploadedImages.push(imageUploadResult.data.url);
                } catch (err) {
                    console.error(`Failed to upload image ${i + 1}:`, err);
                }
            }

            if (uploadedImages.length === 0) {
                setIsUploadingGallery(false);
                alert("All uploads failed. Please try again.");
                return;
            }

            // Add all uploaded images to gallery
            let updatedOrder = null;
            for (const imageUrl of uploadedImages) {
                const result = await userRequest.post("/orders/addgallery", {
                    img: imageUrl,
                    order: modalData._id,
                });
                updatedOrder = result.data;
            }

            setIsUploadingGallery(false);
            
            // Update the orders data in the table
            if (updatedOrder && ordersData && ordersData.payload) {
                const updatedPayload = ordersData.payload.map(order => {
                    if (order._id === modalData._id) {
                        return updatedOrder;
                    }
                    return order;
                });
                setOrdersData({
                    ...ordersData,
                    payload: updatedPayload
                });
            }
            
            // Update the gallery view modal if it's open for this order
            if (updatedOrder && selectedOrderGallery && selectedOrderGallery._id === modalData._id) {
                setSelectedOrderGallery(updatedOrder);
            }
            
            // Refresh the orders list to get updated data from server
            setIsLoaded(false);
            
            resetPhotoGalleryModal();
            alert(`Successfully uploaded ${uploadedImages.length} of ${totalImages} image(s)`);
        } catch (err) {
            setIsUploadingGallery(false);
            alert("Failed to upload images");
            console.log(err);
        }
    };

    const handleWarranty = async () => {
        try {
            const formValues = getWarrantyValues();
            let newImage = undefined;

            if (formValues.image.length !== 0) {
                const imageresult = await generateSignature();
                const imageFormData = new FormData();

                imageFormData.append("file", formValues.image[0]);
                imageFormData.append(
                    "publicKey",
                    "public_0THMWX6MF/cuVk9EPEFy+e0R0Qk="
                );
                imageFormData.append("signature", imageresult.data.signature);
                imageFormData.append("expire", imageresult.data.expire);
                imageFormData.append("token", imageresult.data.token);
                imageFormData.append(
                    "fileName",
                    `${formValues.image[0].name} - ${imageresult.data.expire}`
                );
                imageFormData.append("folder", "warranty");

                const imageUploadResult = await axios.post(
                    "https://upload.imagekit.io/api/v1/files/upload",
                    imageFormData
                );

                newImage = imageUploadResult.data.url;
            }

            const result = await userRequest.post("/warrantyRequest", {
                user: currentUser._id,
                order: modalData,
                message: formValues.message,
                image: newImage,
            });

            if (result.error) {
                alert("Failed to create warranty request");
                return;
            }

            alert("Warranty request created successfully");
            setWarrantyMenu(false);
            resetWarranty();
        } catch (err) {
            console.error(err);
            alert("Failed to create warranty request");
        }
    };

    const handleAddObjective = async () => {
        try {
            const formValues = getObjectivesValues();
            const text = (formValues.objective || "").trim();
            if (!text) {
                alert("Please enter an objective");
                return;
            }
            const result = await userRequest.post("/orders/addobjective", {
                order: modalData._id,
                objective: text,
            });
            if (result.data) {
                setModalData(result.data);
                resetObjectives({ objective: "" });
                if (ordersData && ordersData.payload) {
                    const updatedPayload = ordersData.payload.map((order) =>
                        order._id === modalData._id ? result.data : order
                    );
                    setOrdersData({ ...ordersData, payload: updatedPayload });
                }
            }
        } catch (err) {
            console.error(err);
            alert("Failed to add objective");
        }
    };

    const handleDeleteObjective = async (objective) => {
        try {
            const result = await userRequest.post("/orders/deleteobjective", {
                order: modalData._id,
                objective,
            });
            if (result.data) {
                setModalData(result.data);
                if (ordersData && ordersData.payload) {
                    const updatedPayload = ordersData.payload.map((order) =>
                        order._id === modalData._id ? result.data : order
                    );
                    setOrdersData({ ...ordersData, payload: updatedPayload });
                }
            }
        } catch (err) {
            console.error(err);
            alert("Failed to delete objective");
        }
    };

    const handleAddMilestone = async () => {
        try {
            const formValues = getMilestonesValues();
            const modules = (formValues.modules || "").trim();
            const dueDate = (formValues.dueDate || "").trim();
            if (!modules) {
                alert("Please enter modules");
                return;
            }
            const result = await userRequest.post("/orders/addmilestone", {
                order: modalData._id,
                modules,
                dueDate,
            });
            if (result.data) {
                setModalData(result.data);
                resetMilestones({ modules: "", dueDate: "" });
                if (ordersData && ordersData.payload) {
                    const updatedPayload = ordersData.payload.map((order) =>
                        order._id === modalData._id ? result.data : order
                    );
                    setOrdersData({ ...ordersData, payload: updatedPayload });
                }
            }
        } catch (err) {
            console.error(err);
            alert("Failed to add milestone");
        }
    };

    const handleSaveMonthlyFee = async () => {
        try {
            const raw = (getMonthlyFeeValues().monthlyFees ?? "").toString().trim();
            const result = await userRequest.post("/orders/setmonthlyfee", {
                order: modalData._id,
                monthlyFees: raw,
            });
            if (result.data) {
                setModalData(result.data);
                if (ordersData && ordersData.payload) {
                    const updatedPayload = ordersData.payload.map((order) =>
                        order._id === modalData._id ? result.data : order
                    );
                    setOrdersData({ ...ordersData, payload: updatedPayload });
                }
                setMonthlyFeeMenu(false);
            }
        } catch (err) {
            console.error(err);
            alert("Failed to save monthly fee");
        }
    };

    const handleDeleteMilestone = async (milestone) => {
        try {
            const result = await userRequest.post("/orders/deletemilestone", {
                order: modalData._id,
                modules: milestone.modules,
                dueDate: milestone.dueDate,
            });
            if (result.data) {
                setModalData(result.data);
                if (ordersData && ordersData.payload) {
                    const updatedPayload = ordersData.payload.map((order) =>
                        order._id === modalData._id ? result.data : order
                    );
                    setOrdersData({ ...ordersData, payload: updatedPayload });
                }
            }
        } catch (err) {
            console.error(err);
            alert("Failed to delete milestone");
        }
    };

    const getAdmins = useCallback(async () => {
        // Skip API call for salesperson users
        if (salesperson) {
            return;
        }
        
        // Your logic for fetching admins
        const res = await publicRequest.get("/users/allsalesperson", {
            params: {
                isAdmin: true,
                principle: superadmin ? undefined : inputs.createdBy,
            },
        });
        setUsersData(res.data);
    }, [inputs.createdBy, superadmin, salesperson]);

    const getSuppliers = async () => {
        const res = await publicRequest.get("/users/allsuppliers", {});
        setSuppliersData(res.data);
    };

    const getUsers = async () => {
        const res = await publicRequest.get("/users/all", {
            params: {},
        });
        setCustomersData(res.data);
    };

    const handleUserFilter = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, user: e.value };
        });
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            handleSerialChange(serialNumber);
        }, 1500);

        return () => {
            clearTimeout(timer);
        };
    }, [serialNumber]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await getOrders(dispatch, inputs);
                setOrdersData(result);
                setIsLoaded(true);
            } catch (error) {
                console.error("Error fetching orders:", error);
            }
        };

        if (!isLoaded) {
            fetchData();
        }
        //eslint-disable-next-line
    }, [dispatch, inputs, isLoaded]);

    useEffect(() => {
        if (statusMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [statusMenu]);

    useEffect(() => {
        if (remarksMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [remarksMenu]);

    useEffect(() => {
        if (warrantyMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [warrantyMenu]);

    useEffect(() => {
        if (objectivesMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [objectivesMenu]);

    useEffect(() => {
        if (milestonesMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [milestonesMenu]);

    useEffect(() => {
        if (monthlyFeeMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [monthlyFeeMenu]);

    useEffect(() => {
        if (galleryModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [galleryModalState]);

    useEffect(() => {
        if (photoGalleryModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [photoGalleryModalState]);

    useEffect(() => {
        if (galleryViewModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [galleryViewModalState]);

    useEffect(() => {
        if (installmentMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [installmentMenu]);

    useEffect(() => {
        if (voidMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [voidMenu]);

    useEffect(() => {
        if (acceptMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [acceptMenu]);

    useEffect(() => {
        if (manualInstallmentMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [manualInstallmentMenu]);

    const handleInstallment = async (id) => {
        if (currentUser) {
            try {
                const res = await userRequest.put(`/orders/confirm/${id}`, {
                    commenceDate: commenceDate,
                });

                if (res.data) {
                    alert("Order completed successfully.");
                    setInstallmentMenu(false);
                    window.location.reload();
                } else {
                    alert("Server issue, please contact support");
                    setInstallmentMenu(false);
                }
            } catch (err) {
                alert(
                    "Please make sure remaining balance is less than amount, and use full payment for full payment."
                );
                setInstallmentMenu(false);
            }
        } else {
            alert("Please login before checking out");
            setInstallmentMenu(false);
        }
    };

    const handleManualInstallment = async (data) => {
        if (currentUser) {
            try {
                const res = await userRequest.put(
                    `/orders/installment/${data._id}`,
                    {
                        installment: amount,
                        installmentDiscount: installmentDiscount,
                        cardInterest: cardInterest,
                        installmentRemarks: installmentRemarks,
                        commenceDate: commenceDate,
                        paymentType: payloadpaymentType,
                    }
                );

                if (res.data) {
                    alert("Order installment added successfully.");
                    setManualInstallmentMenu(false);
                    window.location.reload();
                } else {
                    alert("Server issue, please contact support");
                    setManualInstallmentMenu(false);
                }
            } catch (err) {
                alert(
                    "Please make sure remaining balance is less than amount, and use full payment for full payment."
                );
                setManualInstallmentMenu(false);
            }
        } else {
            alert("Please login before checking out");
            setManualInstallmentMenu(false);
        }
    };

    const handlePaymentType = (e) => {
        setPayloadPaymentType(e.value);
    };

    const handleVoid = (id) => {
        voidOrder(id, dispatch);
    };

    const handleAccept = (id) => {
        acceptOrder(id, payloadpaymentType, dispatch);
    };

    const handleInputStatus = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, status: e.value };
        });
    };

    const handleInputUser = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, salesperson: e.value };
        });
    };

    const handleInputPrinciple = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, cashier: e.value };
        });
    };

    const handleInputCoNumber = (e) => {
        setInputs((prev) => {
            return { ...prev, coNumber: e };
        });
        setIsLoaded(false);
    };

    const handleDateFrom = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, dateFrom: e.target.value };
        });
    };

    const handleSerialChange = (e) => {
        setInputs((prev) => {
            return { ...prev, serialNumber: e };
        });
        setIsLoaded(false);
        setSerialNumber(e);
    };

    const handleDateTo = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, dateTo: e.target.value };
        });
    };

    const handleLimitChange = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, limit: e.value };
        });
    };

    const handleInvoiceChange = (e) => {
        setInputs((prev) => {
            return { ...prev, invoice: e };
        });
        setIsLoaded(false);
    };

    const resetGalleryModal = () => {
        setGalleryModalState(false);
        resetGallery();
    };

    const resetPhotoGalleryModal = () => {
        setPhotoGalleryModalState(false);
        resetPhotoGallery();
    };

    const handleDeleteGalleryImage = async (orderId, imageUrl) => {
        if (window.confirm("Are you sure you want to delete this image?")) {
            try {
                const result = await userRequest.post("/orders/deletegallery", {
                    img: imageUrl,
                    order: orderId,
                });

                if (result.data) {                    
                    // Update the selected order gallery state with the new data
                    setSelectedOrderGallery(result.data);
                    
                    // Update the orders data in the table
                    if (ordersData && ordersData.payload) {
                        const updatedPayload = ordersData.payload.map(order => {
                            if (order._id === orderId) {
                                return result.data;
                            }
                            return order;
                        });
                        setOrdersData({
                            ...ordersData,
                            payload: updatedPayload
                        });
                    }
                    
                    // Refresh the orders list to get updated data from server
                    setIsLoaded(false);
                } else {
                    alert("Failed to delete image");
                }
            } catch (err) {
                alert("Failed to delete image");
                console.log(err);
            }
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            handleInvoiceChange(invoice);
        }, 1000);

        return () => {
            clearTimeout(timer);
        };
    }, [invoice]);

    useEffect(() => {
        const timer = setTimeout(() => {
            handleInputCoNumber(coNumber);
        }, 1000);

        return () => {
            clearTimeout(timer);
        };
    }, [coNumber]);

    const handleDelayedInvoiceChange = (e) => {
        setInvoice(e.target.value);
    };

    const handleDelayedCoNumberChange = (e) => {
        setCoNumber(e.target.value);
    };

    const handleResetFilters = () => {
        setInputs(buildDefaultInputs());
        setInvoice("");
        setCoNumber("");
        setSerialNumber("");
        setFilterResetKey((prev) => prev + 1);
        setIsLoaded(false);
    };

    useEffect(() => {
        if (usersData[0] === undefined) {
            getAdmins();
        }
    }, [usersData, getAdmins, dispatch]);

    useEffect(() => {
        if (suppliersData[0] === undefined) {
            getSuppliers();
        }
    }, [suppliersData, dispatch]);

    useEffect(() => {
        if (customersData[0] === undefined) {
            getUsers();
        }
    }, [customersData, dispatch]);

    const productColumns = [
        {
            accessor: "code",
            Header: "Name",
            sortable: false,
            Cell: ({ value }) => <div className="initialPadding">{value}</div>,
        },
        {
            accessor: "quantity",
            Header: "Quantity",
            sortable: false,
            Cell: ({ value }) => <div className="initialPadding">{value}</div>,
        },
        {
            accessor: "amount",
            Header: "Total Price",
            sortable: false,
            Cell: (params) => (
                <div className="initialPadding">
                    RM{" "}
                    {params.row.original.amount
                        ? formatter.format(
                              params.row.original.amount *
                                  params.row.original.price
                          )
                        : "0"}
                </div>
            ),
        },
    ];

    const columns = [
        {
            accessor: "action",
            Header: "Action",
            sortable: false,
            width: "320px",
            Cell: (params) => {
                return (
                    <div className="flex items-center justify-center gap-2 whitespace-nowrap">
                        {!accountant && (
                            <Close
                                className="productListDelete pointer icon text-red-600 hover:text-red-800 transition-colors duration-200"
                                onClick={() => {
                                    setModalData(params.row.original._id);
                                    setVoidMenu(true);
                                }}
                            />
                        )}
                        {/* {params.row.original.status === "completed" && (
                            <AttachFile
                                className="pointer icon text-black hover:text-gray-700 transition-colors duration-200"
                                onClick={() => {
                                    const original = params.row.original;
                                    setModalData(original._id);
                                    setWarrantyMenu(true);
                                }}
                            />
                        )} */}
                        {(params.row.original.status === "pending" || params.row.original.status === "completed") && (
                            <VerifiedUser
                                className="pointer icon text-black hover:text-gray-700 transition-colors duration-200"
                                onClick={() => {
                                    const original = params.row.original;
                                    setModalData(original);
                                    setManualInstallmentMenu(true);
                                }}
                            />
                        )}
                        {params.row.original.status !== "installment" && (
                        <>
                            <CloudDownload
                                className="pointer icon text-black hover:text-gray-700 transition-colors duration-200"
                                onClick={() => {
                                    createCustomerInvoice(params.row.original);
                                }}
                            />
                            <Receipt
                                className="pointer icon text-black hover:text-gray-700 transition-colors duration-200"
                                titleAccess="Download Quotation"
                                onClick={() => {
                                    createQuotation(params.row.original);
                                }}
                            />
                            <Payment
                                className="pointer icon text-black hover:text-gray-700 transition-colors duration-200"
                                titleAccess="Download Official Receipt"
                                onClick={() => {
                                    createOfficialReceipt(params.row.original);
                                }}
                            />
                            <Description
                                className="pointer icon text-black hover:text-gray-700 transition-colors duration-200"
                                titleAccess="Download Proposal"
                                onClick={() => {
                                    createProposal(params.row.original);
                                }}
                            />
                        </>
                        )}
                    </div>
                );
            },
        },
        {
            accessor: "createdAt",
            Header: "Purchase Date",
            sortable: false,
            Cell: ({ value }) => (
                <div className="capitalize">
                    {" "}
                    {moment(value).format("DD/MM/YYYY")}
                </div>
            ),
        },
        {
            accessor: "commenceDate",
            Header: "Commence Date",
            sortable: false,
            Cell: ({ value }) => (
                <div className="capitalize">
                    {" "}
                    {value ? moment(value).format("DD/MM/YYYY") : ""}
                </div>
            ),
        },
        {
            accessor: "product",
            Header: "Products",
            sortable: false,
            Cell: (params) => {
                return (
                    <>
                        <LocalGroceryStore
                            className="icon mr-2"
                            onClick={() => {
                                setModalData(params.row.original.products);
                                setStatusMenu(true);
                            }}
                        />
                        {params.row.original.status !== "INSTALLMENT" && (
                            <Edit
                                className="pointer icon"
                                onClick={() => {
                                    dispatch(clearCart());
                                    dispatch(
                                        editOrderSeedData(params.row.original)
                                    );
                                    history.push(
                                        `/order/${params.row.original._id}`,
                                        {
                                            order: params.row.original,
                                        }
                                    );
                                }}
                            />
                        )}
                    </>
                );
            },
        },
        {
            accessor: "invoiceId",
            Header: "Invoice",
            sortable: false,
            Cell: ({ value }) => {
                return <div className="initialPadding">{value}</div>;
            },
        },
        {
            accessor: "userId",
            Header: "Customer",
            sortable: false,
            Cell: ({ value }) => (
                <div className="initialPadding">{value ? value.name : ""}</div>
            ),
        },
        {
            accessor: "proposalItems",
            Header: "Proposal Items",
            sortable: false,
            Cell: (params) => (
                <div className="flex items-center justify-center gap-2 whitespace-nowrap">
                    <Assignment
                        className="pointer icon text-black hover:text-gray-700 transition-colors duration-200"
                        titleAccess="Order Objectives"
                        onClick={() => {
                            const original = params.row.original;
                            setModalData(original);
                            setObjectivesMenu(true);
                        }}
                    />
                    <Event
                        className="pointer icon text-black hover:text-gray-700 transition-colors duration-200"
                        titleAccess="Order Milestones"
                        onClick={() => {
                            const original = params.row.original;
                            setModalData(original);
                            setMilestonesMenu(true);
                        }}
                    />
                    <Payment
                        className="pointer icon text-black hover:text-gray-700 transition-colors duration-200"
                        titleAccess="Monthly Fee"
                        onClick={() => {
                            const original = params.row.original;
                            setModalData(original);
                            resetMonthlyFee({
                                monthlyFees: original.monthlyFees != null ? String(original.monthlyFees) : "",
                            });
                            setMonthlyFeeMenu(true);
                        }}
                    />
                </div>
            ),
        },
        {
            accessor: "deposit",
            Header: "Paid Amount",
            sortable: false,
            Cell: ({ value, row }) => (
                <div className="initialPadding">
                    {row.original.status === "installment" ? (
                        `RM ${value ? formatter.format(value) : "0"}`
                    ) : (
                        `RM ${row.original.invoicePaid ? formatter.format(row.original.invoicePaid) : "0"}`
                    )}
                </div>
            ),
        },
        {
            accessor: "discount",
            Header: "Discount", 
            sortable: false,
            Cell: ({ value, row }) => (
                <div className="initialPadding">
                    {row.original.status === "installment" ? (
                        `RM ${value ? formatter.format(value) : "0"}`
                    ) : (
                        `RM ${row.original.invoiceDiscount ? formatter.format(row.original.invoiceDiscount) : "0"}`
                    )}
                </div>
            ),
        },
        {
            accessor: "sstIncluded",
            Header: "SST",
            sortable: false,
            Cell: ({ row }) => {
                const order = row.original;
                if (order.status === "installment") {
                    return <div className="initialPadding">-</div>;
                }
                if (order.sstIncluded !== true) {
                    return (
                        <div className="initialPadding">RM {formatter.format(0)}</div>
                    );
                }
                const base =
                    (Number(order.amount) || 0) -
                    (Number(order.discount) || 0);
                const tax = sstAmount(
                    base,
                    order.commenceDate,
                    true
                );
                return (
                    <div className="initialPadding">
                        RM {formatter.format(tax)}
                    </div>
                );
            },
        },
        {
            accessor: "amount", 
            Header: "Total Amount",
            sortable: false,
            Cell: ({ value, row }) => (
                <div className="initialPadding">
                    {row.original.status === "installment" ? (
                        "-"
                    ) : (
                        `RM ${formatter.format(orderTotalDue(row.original))}`
                    )}
                </div>
            ),
        },
        {
            accessor: "paidTotal", 
            Header: "Total Paid",
            sortable: false,
            Cell: ({ value, row }) => (
                <div className="initialPadding">
                    {row.original.status === "installment" ? (
                        "-"
                    ) : (
                        `RM ${formatter.format(row.original.deposit)}`
                    )}
                </div>
            ),
        },
        {
            accessor: "invoicePaid", 
            Header: "Balance",
            sortable: false,
            Cell: ({ value, row }) => {
                const displayBalance = orderBalanceDue(row.original);
                return (
                    <div className="initialPadding">
                        {row.original.status === "installment" ? (
                            "-"
                        ) : (
                            `RM ${formatter.format(displayBalance)}`
                        )}
                    </div>
                );
            },
        },
        {
            accessor: "salesperson",
            Header: "Salesperson",
            sortable: false,
            Cell: ({ row }) => (
                <div className="initialPadding">
                    {row.original.salesperson?.name ?? ""}
                </div>
            ),
        },
        {
            accessor: "cashier",
            Header: "Outlet",
            sortable: false,
            Cell: ({ value }) => (
                <div className="initialPadding">{value ? value.name : ""}</div>
            ),
        },
        {
            accessor: "paymentType",
            Header: "Payment Type",
            sortable: false,
            Cell: ({ value }) => <div className="capitalize">{value}</div>,
        },
        {
            accessor: "remark",
            Header: "Remarks",
            sortable: false,
            Cell: ({ value }) =>
                value ? (
                    <div className="flex items-center">
                        <Comment
                            className="pointer icon"
                            onClick={() => {
                                setSelectedRemarks(value);
                                setRemarksMenu(true);
                            }}
                        />
                    </div>
                ) : (
                    <div></div>
                ),
        },
        {
            accessor: "status",
            Header: "Status",
            sortable: false,
            Cell: ({ value }) => <div className="capitalize">{value}</div>,
        },
        {
            Header: "Proof of Payment",
            accessor: "paymentproof",
            Cell: ({ row: { original }, value }) => (
                <div className="flex justify-center cursor-pointer">
                    <div
                        className="cursor-pointer mr-2"
                        onClick={async () => {
                            setModalData({
                                ...original,
                            });
                            setGalleryModalState(true);
                        }}
                    >
                        <FiPlus />
                    </div>
                    {value ? (
                        <>
                            <FiFile
                                onClick={() => {
                                    window.open(value, "_blank"); // Open image in a new tab if clicked
                                }}
                            ></FiFile>
                        </>
                    ) : (
                        <></>
                    )}
                </div>
            ),
        },
        {
            Header: "Gallery",
            accessor: "gallery",
            Cell: ({ row: { original }, value }) => (
                <div className="flex justify-center cursor-pointer items-center gap-2">
                    <div
                        className="cursor-pointer hover:scale-110 transition-transform"
                        onClick={async () => {
                            setModalData({
                                ...original,
                            });
                            setPhotoGalleryModalState(true);
                        }}
                        title="Add new photo"
                    >
                        <FiPlus className="text-green-600" />
                    </div>
                    {value && value.length > 0 ? (
                        <div 
                            className="flex items-center gap-1 px-2 py-1 bg-blue-50 rounded-full hover:bg-blue-100 transition-colors cursor-pointer"
                            onClick={() => {
                                setSelectedOrderGallery(original);
                                setGalleryViewModalState(true);
                            }}
                            title="View gallery"
                        >
                            <span className="text-xs font-semibold text-blue-600">
                                {value.length}
                            </span>
                            <FiFile className="text-blue-600" />
                        </div>
                    ) : (
                        <span className="text-xs text-gray-400"></span>
                    )}
                </div>
            ),
        },
    ];

    const statusSelectOptions = statusOptions.map((status) => ({
        label: status.label,
        value: status.value,
    }));

    const limitSelectOptions = limitOptions.map((status) => ({
        label: `${status.label}`,
        value: status.value,
    }));

    const salesAgentOptions = usersData.map((user) => ({
        label: `${user.name} - ${user.phoneNumber}`,
        value: user._id,
    }));

    const outletOptions = suppliersData.map((supplier) => ({
        label: `${supplier.name} - ${supplier.phoneNumber}`,
        value: supplier._id,
    }));

    const customerOptions = customersData.map((user) => ({
        label: `${user.name} - ${user.phoneNumber}`,
        value: user._id,
    }));

    return (
        <div className="w-full bg-gradient-to-br from-slate-50 to-blue-50 min-h-screen">
            <div className="productList bg-white rounded-3xl shadow-2xl p-8 m-6 border border-slate-200/50">

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                    <div className="space-y-2">
                        <label className="text-sm font-semibold text-slate-700 tracking-wide">From Date</label>
                        <div className="luxury-select-wrapper">
                            <input
                                className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700"
                                name="dateFrom"
                                value={inputs.dateFrom}
                                type="date"
                                onChange={(e) => handleDateFrom(e)}
                                style={{
                                    background: 'linear-gradient(to right, rgb(248 250 252), rgb(239 246 255))',
                                    border: '2px solid rgb(226 232 240)',
                                    borderRadius: '12px',
                                    padding: '12px 16px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                }}
                            />
                        </div>
                    </div>
                    <div className="space-y-2">
                        <label className="text-sm font-semibold text-slate-700 tracking-wide">To Date</label>
                        <div className="luxury-select-wrapper">
                            <input
                                className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700"
                                name="dateTo"
                                value={inputs.dateTo}
                                type="date"
                                onChange={(e) => handleDateTo(e)}
                                style={{
                                    background: 'linear-gradient(to right, rgb(248 250 252), rgb(239 246 255))',
                                    border: '2px solid rgb(226 232 240)',
                                    borderRadius: '12px',
                                    padding: '12px 16px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                }}
                            />
                        </div>
                    </div>
                    <div className="space-y-2">
                        <label className="text-sm font-semibold text-slate-700 tracking-wide">Order Status</label>
                        <div className="luxury-select-wrapper">
                            <Select
                                key={`status-${filterResetKey}`}
                                options={statusSelectOptions}
                                value={findOption(statusSelectOptions, inputs.status)}
                                onChange={handleInputStatus}
                                placeholder="Select Status"
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        background: 'linear-gradient(to right, rgb(248 250 252), rgb(239 246 255))',
                                        border: '2px solid rgb(226 232 240)',
                                        borderRadius: '12px',
                                        padding: '6px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        boxShadow: 'none',
                                        '&:hover': {
                                            borderColor: 'rgb(59 130 246)',
                                        }
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? 'rgb(59 130 246)' : state.isFocused ? 'rgb(239 246 255)' : 'white',
                                        color: state.isSelected ? 'white' : 'rgb(51 65 85)',
                                        fontWeight: '500',
                                        '&:hover': {
                                            backgroundColor: 'rgb(239 246 255)',
                                        }
                                    }),
                                    menu: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                    }),
                                    menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                    })
                                }}
                                menuPortalTarget={document.body}
                            />
                        </div>
                    </div>
                    <div className="space-y-2">
                        {admin && !staff && (
                            <>
                                <label className="text-sm font-semibold text-slate-700 tracking-wide">View Mode</label>
                                <div className="luxury-select-wrapper">
                                    <Select
                                        key={`limit-${filterResetKey}`}
                                        options={limitSelectOptions}
                                        value={findOption(limitSelectOptions, inputs.limit)}
                                        onChange={handleLimitChange}
                                        placeholder={"View Mode"}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                background: 'linear-gradient(to right, rgb(248 250 252), rgb(239 246 255))',
                                                border: '2px solid rgb(226 232 240)',
                                                borderRadius: '12px',
                                                padding: '6px',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                boxShadow: 'none',
                                                '&:hover': {
                                                    borderColor: 'rgb(59 130 246)',
                                                }
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                backgroundColor: state.isSelected ? 'rgb(59 130 246)' : state.isFocused ? 'rgb(239 246 255)' : 'white',
                                                color: state.isSelected ? 'white' : 'rgb(51 65 85)',
                                                fontWeight: '500',
                                                '&:hover': {
                                                    backgroundColor: 'rgb(239 246 255)',
                                                }
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            })
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                    <div className="space-y-2">
                        <label className="text-sm font-semibold text-slate-700 tracking-wide">Invoice ID</label>
                        <div className="luxury-select-wrapper">
                            <input
                                className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700 placeholder-slate-400"
                                name="invoice"
                                value={invoice}
                                type="string"
                                placeholder="Search by Invoice ID"
                                onChange={handleDelayedInvoiceChange}
                                style={{
                                    background: 'linear-gradient(to right, rgb(248 250 252), rgb(239 246 255))',
                                    border: '2px solid rgb(226 232 240)',
                                    borderRadius: '12px',
                                    padding: '12px 16px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                }}
                            />
                        </div>
                    </div>
                    <div className="space-y-2">
                        <label className="text-sm font-semibold text-slate-700 tracking-wide">CO Number</label>
                        <div className="luxury-select-wrapper">
                            <input
                                className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700 placeholder-slate-400"
                                name="coNumber"
                                value={coNumber}
                                type="string"
                                placeholder="Search by CO Number"
                                onChange={handleDelayedCoNumberChange}
                                style={{
                                    background: 'linear-gradient(to right, rgb(248 250 252), rgb(239 246 255))',
                                    border: '2px solid rgb(226 232 240)',
                                    borderRadius: '12px',
                                    padding: '12px 16px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                }}
                            />
                        </div>
                    </div>
                    {!salesperson && (
                        <div className="space-y-2">
                            <label className="text-sm font-semibold text-slate-700 tracking-wide">Sales Agent</label>
                            <div className="luxury-select-wrapper">
                                <Select
                                    key={`sales-${filterResetKey}`}
                                    options={salesAgentOptions}
                                    value={findOption(salesAgentOptions, inputs.salesperson)}
                                    onChange={handleInputUser}
                                    placeholder="Select Sales Agent"
                                    onClick={() =>
                                        usersData[0] === undefined ? getAdmins() : {}
                                    }
                                                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    background: 'linear-gradient(to right, rgb(248 250 252), rgb(239 246 255))',
                                                    border: '2px solid rgb(226 232 240)',
                                                    borderRadius: '12px',
                                                    padding: '6px',
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    boxShadow: 'none',
                                                    '&:hover': {
                                                        borderColor: 'rgb(59 130 246)',
                                                    }
                                                }),
                                                option: (base, state) => ({
                                                    ...base,
                                                    backgroundColor: state.isSelected ? 'rgb(59 130 246)' : state.isFocused ? 'rgb(239 246 255)' : 'white',
                                                    color: state.isSelected ? 'white' : 'rgb(51 65 85)',
                                                    fontWeight: '500',
                                                }),
                                                menu: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                }),
                                                menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                })
                                            }}
                                            menuPortalTarget={document.body}
                                />
                            </div>
                        </div>
                    )}
                    {superadmin && (
                        <div className="space-y-2">
                            <label className="text-sm font-semibold text-slate-700 tracking-wide">Outlet</label>
                            <div className="luxury-select-wrapper">
                            <Select
                                key={`outlet-${filterResetKey}`}
                                options={outletOptions}
                                value={findOption(outletOptions, inputs.cashier)}
                                onChange={handleInputPrinciple}
                                placeholder="Select Outlet"
                                onClick={() =>
                                    suppliersData[0] === undefined
                                        ? getSuppliers()
                                        : {}
                                }
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            background: 'linear-gradient(to right, rgb(248 250 252), rgb(239 246 255))',
                                            border: '2px solid rgb(226 232 240)',
                                            borderRadius: '12px',
                                            padding: '6px',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            boxShadow: 'none',
                                            '&:hover': {
                                                borderColor: 'rgb(59 130 246)',
                                            }
                                        }),
                                        option: (base, state) => ({
                                            ...base,
                                            backgroundColor: state.isSelected ? 'rgb(59 130 246)' : state.isFocused ? 'rgb(239 246 255)' : 'white',
                                            color: state.isSelected ? 'white' : 'rgb(51 65 85)',
                                            fontWeight: '500',
                                            '&:hover': {
                                                backgroundColor: 'rgb(239 246 255)',
                                            }
                                        }),
                                        menu: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                        }),
                                        menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                        })
                                    }}
                                    menuPortalTarget={document.body}
                                />
                            </div>
                        </div>
                    )}
                    <div className="space-y-2">
                        <label className="text-sm font-semibold text-slate-700 tracking-wide">Customer</label>
                        <div className="luxury-select-wrapper">
                            <Select
                                key={`customer-${filterResetKey}`}
                                options={customerOptions}
                                value={findOption(customerOptions, inputs.user)}
                                placeholder="Select Customer"
                                onChange={handleUserFilter}
                                onClick={() =>
                                    customersData[0] === undefined ? getUsers() : {}
                                }
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        background: 'linear-gradient(to right, rgb(248 250 252), rgb(239 246 255))',
                                        border: '2px solid rgb(226 232 240)',
                                        borderRadius: '12px',
                                        padding: '6px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        boxShadow: 'none',
                                        '&:hover': {
                                            borderColor: 'rgb(59 130 246)',
                                        }
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? 'rgb(59 130 246)' : state.isFocused ? 'rgb(239 246 255)' : 'white',
                                        color: state.isSelected ? 'white' : 'rgb(51 65 85)',
                                        fontWeight: '500',
                                        '&:hover': {
                                            backgroundColor: 'rgb(239 246 255)',
                                        }
                                    }),
                                    menu: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                    }),
                                    menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                    })
                                }}
                                menuPortalTarget={document.body}
                            />
                        </div>
                    </div>
                </div>

                <div className="flex justify-start gap-4 mb-8 order-action-buttons">
                    <button
                        onClick={handleResetFilters}
                        className="px-8 py-4 bg-gradient-to-r from-slate-700 to-slate-800 hover:from-slate-800 hover:to-slate-900 text-white font-bold rounded-xl shadow-xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl flex items-center gap-3 border border-slate-600"
                    >
                        <span className="text-amber-400 text-lg">🔄</span>
                        <span className="text-black tracking-wide">Reset Filters</span>
                    </button>

                    {superadmin && (
                        <>
                            <button
                                onClick={() => {
                                    let payload = [];
                                    ordersData.payload.forEach((order, i) => {
                                        let productCodes = order.products
                                            .map(
                                                (product) =>
                                                    `${product.quantity} x ${product.code} (RM ${product.price})`
                                            )
                                            .join(", ");
                                        payload.push({
                                            No: i + 1,
                                            Invoice: order.invoiceId,
                                            Customer: order.userId.name,
                                            PhoneNumber:
                                                order.userId.phoneNumber,
                                            SKU: productCodes,
                                            Retail: Number(order.amount),
                                            Discount: Number(order.discount),
                                            Sales: Number(
                                                order.amount -
                                                    order.discount -
                                                    (order.deposit
                                                        ? order.deposit
                                                        : 0)
                                            ),
                                            Deposit: Number(
                                                order.deposit
                                                    ? order.deposit
                                                    : 0
                                            ),
                                            PaymentType: order.paymentType,
                                            PurchaseDate: moment(
                                                order.createdAt
                                            ).format("YYYY-MM-DD"),
                                        });
                                    });
                                    excel({
                                        excelData: payload,
                                        fileName: `SSR-Orders-${moment(
                                            inputs.dateFrom
                                        ).format("DD-MM-YYYY")}-to-${moment(
                                            inputs.dateTo
                                        ).format("DD-MM-YYYY")}`,
                                    });
                                }}
                                className="px-8 py-4 bg-gradient-to-r from-amber-500 to-yellow-500 hover:from-amber-600 hover:to-yellow-600 text-slate-800 font-bold rounded-xl shadow-xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl flex items-center gap-3 border border-amber-300"
                            >
                                <span className="text-slate-700 text-lg">📊</span>
                                <span className="tracking-wide">Export Excel</span>
                            </button>

                            {inputs.status === "pending" &&
                                inputs.user !== undefined && (
                                    <button
                                        onClick={() => {
                                            const mergeItems = (items) => {
                                                // Initialize the merged result object
                                                const merged = {
                                                    address: "-",
                                                    amount: 0,
                                                    discount: 0,
                                                    products: [],
                                                    invoiceIds: [],
                                                    cashier: items[0].cashier, // Assuming cashier is the same for all items
                                                    createdAt:
                                                        new Date().toISOString(),
                                                    createdBy:
                                                        items[0].createdBy, // Assuming createdBy is the same for all items
                                                    paymentType:
                                                        items[0].paymentType, // Assuming paymentType is the same for all items
                                                    salesType:
                                                        items[0].salesType, // Assuming salesType is the same for all items
                                                    status: items[0].status, // Assuming status is the same for all items
                                                    updatedAt:
                                                        new Date().toISOString(),
                                                    userId: items[0].userId, // Assuming userId is the same for all items
                                                    __v: 0,
                                                    _id: `merged_${Date.now()}`, // Generating a new ID for the merged item
                                                };

                                                // Loop through each item and merge the fields
                                                items.forEach(
                                                    ({
                                                        amount,
                                                        discount,
                                                        products,
                                                        createdAt,
                                                        invoiceId,
                                                        plate,
                                                    }) => {
                                                        merged.amount += amount;
                                                        merged.discount +=
                                                            discount;
                                                        products.forEach(
                                                            (product) => {
                                                                product.productdate =
                                                                    moment(
                                                                        createdAt
                                                                    ).format(
                                                                        "YYYY-MM-DD"
                                                                    );
                                                                product.invoiceId =
                                                                    invoiceId;
                                                                product.plate =
                                                                    plate;
                                                            }
                                                        );

                                                        merged.products = [
                                                            ...merged.products,
                                                            ...products,
                                                        ];
                                                    }
                                                );

                                                return merged;
                                            };

                                            const mergedItem = mergeItems(
                                                ordersData.payload
                                            );

                                            createBulk(mergedItem);
                                        }}
                                        className="px-8 py-4 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-bold rounded-xl shadow-xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl flex items-center gap-3 border border-blue-500"
                                    >
                                        <span className="text-blue-200 text-lg">📄</span>
                                        <span className="tracking-wide">Customer Statement</span>
                                    </button>
                                )}
                        </>
                    )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8 order-stats-container">
                    <div className="bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 rounded-2xl p-8 shadow-2xl border border-blue-500/30 relative overflow-hidden order-stats-card">
                        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-400/20 to-transparent rounded-full -mr-16 -mt-16"></div>
                        <div className="relative z-10">
                            <div className="flex items-center justify-between mb-4">
                                <span className="text-blue-100 text-lg font-semibold tracking-wide order-stats-title">Total Orders</span>
                                <div className="w-12 h-12 bg-blue-500/30 rounded-xl flex items-center justify-center order-stats-icon">
                                    <span className="text-2xl">📊</span>
                                </div>
                            </div>
                            <div className="text-4xl font-bold text-white mb-2 order-stats-value">
                                {ordersData?.totalCount || 0}
                            </div>
                            <div className="text-blue-200 text-sm order-stats-subtitle">Inhome Solar Orders</div>
                        </div>
                    </div>

                    <div className="bg-gradient-to-br from-yellow-400 via-amber-400 to-yellow-500 rounded-2xl p-8 shadow-2xl border border-yellow-300/30 relative overflow-hidden order-stats-card">
                        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-yellow-300/20 to-transparent rounded-full -mr-16 -mt-16"></div>
                        <div className="relative z-10">
                            <div className="flex items-center justify-between mb-4">
                                <span className="text-yellow-900 text-lg font-semibold tracking-wide order-stats-title">Total Amount</span>
                                <div className="w-12 h-12 bg-yellow-300/30 rounded-xl flex items-center justify-center order-stats-icon">
                                    <span className="text-2xl">💰</span>
                                </div>
                            </div>
                            <div className="text-4xl font-bold text-yellow-900 mb-2 order-stats-value order-total-amount">
                                RM {formatter.format(ordersData?.totalAmount || 0)}
                            </div>
                            <div className="text-yellow-800 text-sm order-stats-subtitle">Inhome Solar Revenue</div>
                        </div>
                    </div>
                </div>
                <Table
                    data={ordersData ? ordersData.payload : []}
                    columns={columns}
                    pageCount={ordersData ? ordersData.totalPages : 1}
                    totalCount={ordersData ? ordersData.totalCount : 0}
                    updatePagination={setInputs}
                    paginationState={inputs}
                    updateLoaded={setIsLoaded}
                />
            </div>

            {statusMenu && (
                <div className="overlayContainer">
                    <div className="bigcenter">
                        <div
                            className="close"
                            onClick={() => setStatusMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="updatemodalContainer">
                            <div className="updateOrder">
                                <h1 className="updateProductTitle text-xl font-semibold">
                                    Products({modalData.length})
                                </h1>
                                <Table
                                    data={modalData}
                                    columns={productColumns}
                                    hidePagination={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {voidMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setVoidMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Confirm Void Order?
                                </h3>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={() => {
                                            handleVoid(modalData);
                                            setVoidMenu(false);
                                        }}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => {
                                            setVoidMenu(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {acceptMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setAcceptMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Confirm Accept Order?
                                </h3>
                                <div className="">
                                    <label className="flex justify-start text-lynch">
                                        Payment Type
                                    </label>
                                    <Select
                                        options={paymentType.map(
                                            (paymentType, i) => {
                                                return {
                                                    label: paymentType.label,
                                                    value: paymentType.value,
                                                };
                                            }
                                        )}
                                        onChange={handlePaymentType}
                                    />
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={() => {
                                            handleAccept(modalData);
                                            setAcceptMenu(false);
                                        }}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => {
                                            setAcceptMenu(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {installmentMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setInstallmentMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Confirm Payment & Commence Project Warranty
                                </h3>

                                <div className="flex flex-col items-center mb-4">
                                    <input
                                        className=" my-8 p-3 w-full max-w-md rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                        name="commenceDate"
                                        value={commenceDate}
                                        type="date"
                                        onChange={(e) =>
                                            setCommenceDate(e.target.value)
                                        }
                                    />
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={() => {
                                            handleInstallment(modalData);
                                        }}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => {
                                            setInstallmentMenu(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {manualInstallmentMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setManualInstallmentMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle mb-4">
                                    Installment
                                </h3>

                                <div className="flex flex-col items-center mb-4">
                                    <div className="w-full mb-4">
                                        <div className="flex justify-between items-center mb-2">
                                            <label className="text-sm font-medium text-lynch">
                                                Amount
                                            </label>
                                            <span className="text-sm font-medium text-red-600">
                                                Remaining Balance: RM{" "}
                                                {orderBalanceDue(modalData)}
                                            </span>
                                        </div>
                                        <input
                                            className="p-3 w-full rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                            name="amount"
                                            type="number"
                                            placeholder="Enter payment amount"
                                            max={orderBalanceDue(modalData)}
                                            onChange={(e) =>
                                                setAmount(e.target.value)
                                            }
                                        />
                                    </div>

                                    <div className="w-full mb-4">
                                        <label className="block text-sm text-left font-medium text-lynch mb-2">
                                            Discount
                                        </label>
                                        <input
                                            className="p-3 w-full rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                            name="installmentDiscount"
                                            type="number"
                                            value={installmentDiscount}
                                            placeholder="Enter discount amount"
                                            onChange={(e) =>
                                                setInstallmentDiscount(e.target.value)
                                            }
                                        />
                                    </div>

                                    <div className="w-full mb-4">
                                        <label className="block text-sm text-left font-medium text-lynch mb-2">
                                            Card Interest
                                        </label>
                                        <input
                                            className="p-3 w-full rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                            name="installmentDiscount"
                                            type="number"
                                            value={cardInterest}
                                            placeholder="Enter discount amount"
                                            onChange={(e) =>
                                                setCardInterest(e.target.value)
                                            }
                                        />
                                    </div>
                                 

                                    <div className="w-full mb-4">
                                        <label className="block text-sm text-left font-medium text-lynch mb-2">
                                            Payment Type
                                        </label>
                                        <Select
                                            options={paymentType.map((type) => ({
                                                label: type.label,
                                                value: type.value,
                                            }))}
                                            onChange={(e) =>
                                                setPayloadPaymentType(e.value)
                                            }
                                            placeholder="Select payment type"
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    minHeight: '42px',
                                                    padding: '0 12px',
                                                    borderRadius: '0.5rem',
                                                    backgroundColor: 'rgb(249, 250, 251)',
                                                    borderColor: 'rgb(209, 213, 219)',
                                                    fontSize: '0.875rem',
                                                    fontWeight: '600',
                                                    color: 'rgb(75, 85, 99)',
                                                    textAlign: 'left',
                                                    '&:hover': {
                                                        borderColor: 'rgb(59, 130, 246)',
                                                    },
                                                    '&:focus': {
                                                        outline: 'none',
                                                        boxShadow: '0 0 0 2px rgb(59 130 246 / 0.25)',
                                                        borderColor: 'rgb(59, 130, 246)',
                                                    }
                                                }),
                                                option: (base, state) => ({
                                                    ...base,
                                                    backgroundColor: state.isSelected ? 'rgb(59, 130, 246)' : state.isFocused ? 'rgb(239, 246, 255)' : 'white',
                                                    color: state.isSelected ? 'white' : 'rgb(75, 85, 99)',
                                                    fontSize: '0.875rem',
                                                    fontWeight: '600',
                                                    '&:hover': {
                                                        backgroundColor: 'rgb(239, 246, 255)',
                                                    }
                                                }),
                                                menu: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                }),
                                                menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                }),
                                                valueContainer: (base) => ({
                                                    ...base,
                                                    padding: '0',
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    textAlign: 'left',
                                                    marginLeft: '0'
                                                })
                                            }}
                                            menuPortalTarget={document.body}
                                        />
                                    </div>

                                    <div className="w-full mb-4">
                                        <label className="block text-sm text-left font-medium text-lynch mb-2">
                                            Payment Date
                                        </label>
                                        <input
                                            className="p-3 w-full rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                            name="commenceDate"
                                            value={commenceDate}
                                            type="date"
                                            onChange={(e) =>
                                                setCommenceDate(e.target.value)
                                            }
                                        />
                                    </div>

                                    <div className="w-full mb-4">
                                        <label className="block text-sm text-left font-medium text-lynch mb-2">
                                            Remarks
                                        </label>
                                        <textarea
                                            className="p-3 w-full rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                            name="installmentRemarks"
                                            rows="3"
                                            placeholder="Enter remarks (optional)"
                                            value={installmentRemarks}
                                            onChange={(e) =>
                                                setInstallmentRemarks(e.target.value)
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="flex justify-center gap-4 mt-6">
                                    <button
                                        className="px-6 py-2 bg-green-500 hover:bg-green-600 text-white font-medium rounded-lg transition-colors duration-200"
                                        onClick={() => {
                                            handleManualInstallment(modalData);
                                        }}
                                    >
                                        Confirm Payment
                                    </button>
                                    <button
                                        className="px-6 py-2 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-colors duration-200"
                                        onClick={() => {
                                            setManualInstallmentMenu(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {warrantyMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setWarrantyMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Warranty Request
                                </h3>
                                <form
                                    onSubmit={handleWarrantySubmit(
                                        handleWarranty
                                    )}
                                    className="w-full"
                                >
                                    <div className="flex flex-col items-center mb-4">
                                        <div className="w-full mb-4">
                                            <label className="block text-sm font-medium text-lynch mb-2">
                                                Message
                                            </label>
                                            <textarea
                                                className="w-full p-3 rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                                rows="4"
                                                {...warrantyRegister("message")}
                                                placeholder="Describe the issue..."
                                            />
                                        </div>
                                        <div className="w-full">
                                            <label className="block text-sm font-medium text-lynch mb-2">
                                                Upload Image
                                            </label>
                                            <input
                                                className="w-full p-3 rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                                type="file"
                                                accept="image/*"
                                                {...warrantyRegister("image")}
                                            />
                                        </div>
                                    </div>
                                    <div className="buttonContainer">
                                        <button
                                            type="submit"
                                            className="confirm pointer green"
                                        >
                                            Submit
                                        </button>
                                        <button
                                            type="button"
                                            className="cancel pointer red"
                                            onClick={() => {
                                                setWarrantyMenu(false);
                                                resetWarranty();
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {milestonesMenu && modalData && (
                <div
                    className="overlayContainer"
                    onClick={() => {
                        setMilestonesMenu(false);
                        resetMilestones();
                    }}
                >
                    <div
                        className="center"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle mb-4">
                                    Order Milestones
                                </h3>
                                <form
                                    onSubmit={handleMilestonesSubmit(
                                        handleAddMilestone
                                    )}
                                    className="w-full"
                                >
                                    <div className="flex flex-col items-center mb-4">
                                        <div className="w-full mb-4">
                                            <label className="block text-sm font-medium text-lynch mb-2">
                                                Modules
                                            </label>
                                            <input
                                                className="w-full p-3 rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                                type="text"
                                                {...milestonesRegister("modules")}
                                                placeholder="Enter modules..."
                                            />
                                        </div>
                                        <div className="w-full mb-4">
                                            <label className="block text-sm font-medium text-lynch mb-2">
                                                Due Date
                                            </label>
                                            <input
                                                className="w-full p-3 rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                                type="text"
                                                {...milestonesRegister("dueDate")}
                                                placeholder="Enter due date..."
                                            />
                                        </div>
                                    </div>
                                    <div className="flex gap-2 mb-4">
                                        <button
                                            type="submit"
                                            className="confirm pointer green"
                                        >
                                            Add
                                        </button>
                                    </div>
                                </form>
                                <div className="w-full mb-4">
                                    <label className="block text-sm font-medium text-lynch mb-2">
                                        Existing Milestones
                                    </label>
                                    {(modalData.milestones || []).length > 0 ? (
                                        <table className="w-full border-collapse border border-gray-300">
                                            <thead>
                                                <tr className="bg-cool-gray">
                                                    <th className="border border-gray-300 p-2 text-left text-sm font-semibold text-lynch">
                                                        #
                                                    </th>
                                                    <th className="border border-gray-300 p-2 text-left text-sm font-semibold text-lynch">
                                                        Modules
                                                    </th>
                                                    <th className="border border-gray-300 p-2 text-left text-sm font-semibold text-lynch">
                                                        Due Date
                                                    </th>
                                                    <th className="border border-gray-300 p-2 text-center text-sm font-semibold text-lynch w-20">
                                                        Action
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(modalData.milestones || []).map(
                                                    (m, idx) => (
                                                        <tr key={idx}>
                                                            <td className="border border-gray-300 p-2 text-sm text-lynch">
                                                                {idx + 1}
                                                            </td>
                                                            <td className="border border-gray-300 p-2 text-sm text-lynch">
                                                                {m.modules || ""}
                                                            </td>
                                                            <td className="border border-gray-300 p-2 text-sm text-lynch">
                                                                {m.dueDate || ""}
                                                            </td>
                                                            <td className="border border-gray-300 p-2 text-center">
                                                                <button
                                                                    type="button"
                                                                    className="p-1 text-red-600 hover:text-red-800 hover:bg-red-50 rounded"
                                                                    onClick={() =>
                                                                        handleDeleteMilestone(m)
                                                                    }
                                                                    title="Delete"
                                                                >
                                                                    <Delete fontSize="small" />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <p className="text-sm text-gray-500 italic">
                                            No milestones yet.
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {monthlyFeeMenu && modalData && (
                <div
                    className="overlayContainer"
                    onClick={() => {
                        setMonthlyFeeMenu(false);
                        resetMonthlyFee();
                    }}
                >
                    <div
                        className="center"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle mb-4">
                                    Monthly Fee
                                </h3>
                                <form
                                    onSubmit={handleMonthlyFeeSubmit(handleSaveMonthlyFee)}
                                    className="w-full"
                                >
                                    <div className="w-full mb-4">
                                        <label className="block text-sm font-medium text-lynch mb-2">
                                            Monthly Fee (RM)
                                        </label>
                                        <input
                                            className="w-full p-3 rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            {...monthlyFeeRegister("monthlyFees")}
                                            placeholder="Leave blank to hide on the proposal"
                                        />
                                    </div>
                                    <div className="flex gap-2 mb-4">
                                        <button
                                            type="submit"
                                            className="confirm pointer green"
                                        >
                                            Save
                                        </button>
                                        <button
                                            type="button"
                                            className="confirm pointer"
                                            onClick={() => {
                                                setMonthlyFeeMenu(false);
                                                resetMonthlyFee();
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {objectivesMenu && modalData && (
                <div
                    className="overlayContainer"
                    onClick={() => {
                        setObjectivesMenu(false);
                        resetObjectives();
                    }}
                >
                    <div
                        className="center"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle mb-4">
                                    Order Objectives
                                </h3>
                                <form
                                    onSubmit={handleObjectivesSubmit(
                                        handleAddObjective
                                    )}
                                    className="w-full"
                                >
                                    <div className="flex flex-col items-center mb-4">
                                        <div className="w-full mb-4">
                                            <label className="block text-sm font-medium text-lynch mb-2">
                                                Add Objective
                                            </label>
                                            <textarea
                                                className="w-full p-3 rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                                rows="4"
                                                {...objectivesRegister("objective")}
                                                placeholder="Enter objective..."
                                            />
                                        </div>
                                    </div>
                                    <div className="flex gap-2 mb-4">
                                        <button
                                            type="submit"
                                            className="confirm pointer green"
                                        >
                                            Add
                                        </button>
                                    </div>
                                </form>
                                <div className="w-full mb-4">
                                    <label className="block text-sm font-medium text-lynch mb-2">
                                        Existing Objectives
                                    </label>
                                    {(modalData.objectives || []).length > 0 ? (
                                        <table className="w-full border-collapse border border-gray-300">
                                            <thead>
                                                <tr className="bg-cool-gray">
                                                    <th className="border border-gray-300 p-2 text-left text-sm font-semibold text-lynch">
                                                        #
                                                    </th>
                                                    <th className="border border-gray-300 p-2 text-left text-sm font-semibold text-lynch">
                                                        Objective
                                                    </th>
                                                    <th className="border border-gray-300 p-2 text-center text-sm font-semibold text-lynch w-20">
                                                        Action
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(modalData.objectives || []).map(
                                                    (obj, idx) => (
                                                        <tr key={idx}>
                                                            <td className="border border-gray-300 p-2 text-sm text-lynch">
                                                                {idx + 1}
                                                            </td>
                                                            <td className="border border-gray-300 p-2 text-sm text-lynch">
                                                                {obj}
                                                            </td>
                                                            <td className="border border-gray-300 p-2 text-center">
                                                                <button
                                                                    type="button"
                                                                    className="p-1 text-red-600 hover:text-red-800 hover:bg-red-50 rounded"
                                                                    onClick={() =>
                                                                        handleDeleteObjective(
                                                                            obj
                                                                        )
                                                                    }
                                                                    title="Delete"
                                                                >
                                                                    <Delete fontSize="small" />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <p className="text-sm text-gray-500 italic">
                                            No objectives yet.
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {galleryModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => resetGalleryModal()}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle mb-4">
                                    Upload Payment Proof
                                </h3>
                                <form
                                    onSubmit={handleGallerySubmit(handleAddGallery)}
                                    className="w-full"
                                >
                                    <div className="flex flex-col items-center mb-4">
                                        <div className="w-full mb-4">
                                            <label className="block text-sm font-medium text-lynch mb-2">
                                                Select Image File
                                            </label>
                                            <input
                                                className="w-full p-3 rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                                name="image"
                                                {...galleryRegister("image")}
                                                type="file"
                                                accept="image/*"
                                            />
                                        </div>
                                    </div>
                                    <div className="flex justify-center gap-4 mt-6">
                                        <button
                                            type="submit"
                                            className="px-6 py-2 bg-green-500 hover:bg-green-600 text-white font-medium rounded-lg transition-colors duration-200"
                                        >
                                            Upload Image
                                        </button>
                                        <button
                                            type="button"
                                            className="px-6 py-2 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-colors duration-200"
                                            onClick={() => {
                                                resetGalleryModal();
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {photoGalleryModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => !isUploadingGallery && resetPhotoGalleryModal()}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle mb-4">
                                    Add Photos to Gallery
                                </h3>
                                {isUploadingGallery ? (
                                    <div className="flex flex-col items-center justify-center py-12">
                                        <div className="relative">
                                            <div className="w-24 h-24 border-8 border-blue-200 rounded-full animate-pulse"></div>
                                            <div className="w-24 h-24 border-8 border-t-blue-600 border-r-transparent border-b-transparent border-l-transparent rounded-full animate-spin absolute top-0 left-0"></div>
                                        </div>
                                        <div className="mt-6 text-center">
                                            <p className="text-lg font-semibold text-gray-700 mb-2">
                                                Uploading Images...
                                            </p>
                                            <p className="text-sm text-gray-600">
                                                Processing {uploadProgress.current} of {uploadProgress.total}
                                            </p>
                                            <div className="w-64 h-2 bg-gray-200 rounded-full mt-4 overflow-hidden">
                                                <div 
                                                    className="h-full bg-blue-600 transition-all duration-300 ease-out"
                                                    style={{ width: `${(uploadProgress.current / uploadProgress.total) * 100}%` }}
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <form
                                        onSubmit={handlePhotoGallerySubmit(handleAddPhotoGallery)}
                                        className="w-full"
                                    >
                                        <div className="flex flex-col items-center mb-4">
                                            <div className="w-full mb-4">
                                                <label className="block text-sm font-medium text-lynch mb-2">
                                                    Select Image Files (Multiple)
                                                </label>
                                                <input
                                                    className="w-full p-3 rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                                    name="image"
                                                    {...photoGalleryRegister("image")}
                                                    type="file"
                                                    accept="image/*"
                                                    multiple
                                                />
                                                <p className="text-xs text-gray-500 mt-2">
                                                    💡 You can select multiple images at once
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex justify-center gap-4 mt-6">
                                            <button
                                                type="submit"
                                                className="px-6 py-2 bg-green-500 hover:bg-green-600 text-white font-medium rounded-lg transition-colors duration-200"
                                            >
                                                Upload Images
                                            </button>
                                            <button
                                                type="button"
                                                className="px-6 py-2 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-colors duration-200"
                                                onClick={() => {
                                                    resetPhotoGalleryModal();
                                                }}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {remarksMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setRemarksMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">Remarks</h3>
                                <div className="flex flex-col items-center mb-4">
                                    <div className="w-full mb-4">
                                        <textarea
                                            className="w-full p-3 rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                            rows="6"
                                            value={selectedRemarks}
                                            readOnly
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {galleryViewModalState && selectedOrderGallery && (
                <div className="overlayContainer">
                    <div className="bigcenter">
                        <div className="updatemodalContainer" style={{ maxWidth: '1200px', width: '100%', position: 'relative' }}>
                            <div className="updateOrder">
                                <div className="flex justify-between items-center mb-6">
                                    <div className="flex-1"></div>
                                    <h3 className="updateProductTitle text-2xl font-bold text-center flex-1">
                                        Installation Gallery
                                    </h3>
                                    <div className="flex-1 flex justify-end">
                                        <button
                                            onClick={() => {
                                                setGalleryViewModalState(false);
                                                setSelectedOrderGallery(null);
                                            }}
                                            className="bg-red-500 hover:bg-red-600 text-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg transition-all duration-200"
                                            title="Close"
                                        >
                                            <Close style={{ fontSize: '24px' }} />
                                        </button>
                                    </div>
                                </div>
                                <div className="flex justify-center items-center mb-6 px-4">
                                    <div className="text-sm text-gray-600">
                                        <span className="font-semibold">Total Images:</span> {selectedOrderGallery.gallery?.length || 0}
                                    </div>
                                </div>
                                {selectedOrderGallery.gallery && selectedOrderGallery.gallery.length > 0 ? (
                                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 p-6 max-h-[70vh] overflow-y-auto">
                                        {selectedOrderGallery.gallery.map((imageUrl, index) => (
                                            <div 
                                                key={index} 
                                                className="relative group rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
                                                style={{
                                                    aspectRatio: '1',
                                                    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
                                                }}
                                            >
                                                <img
                                                    src={imageUrl}
                                                    alt={`Installation ${index + 1}`}
                                                    className="w-full h-full object-cover cursor-pointer"
                                                    onClick={() => window.open(imageUrl, '_blank')}
                                                    onError={(e) => {
                                                        e.target.src = 'https://via.placeholder.com/300?text=Image+Not+Found';
                                                    }}
                                                />
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleDeleteGalleryImage(selectedOrderGallery._id, imageUrl);
                                                    }}
                                                    className="absolute z-30 bg-red-600 hover:bg-red-700 text-white rounded-full w-9 h-9 flex items-center justify-center shadow-xl transition-all duration-200 opacity-90 hover:opacity-100"
                                                    title="Delete image"
                                                    style={{
                                                        top: '1rem',
                                                        right: '0.5rem',
                                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                                        position: 'absolute',
                                                        transform: 'translateY(-50%)',
                                                    }}
                                                >
                                                    <Close style={{ fontSize: '20px', fontWeight: 'bold' }} />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="text-center py-12">
                                        <p className="text-gray-500 text-lg">No images in gallery</p>
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
